import React, { useState } from "react";
import { toast } from "sonner";
import ConfirmDeleteModal from "./ConfirmDeleteModal";
import { deleteItem, downloadFile } from "../../services/fileSystemService";

function FileGridItem({
  item,
  onFolderClick,
  onFileClick,
  getFileTypeIcon,
  formatFileSize,
  onRefresh,
  styles,
}) {
  const [isDeleting, setIsDeleting] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      setIsDeleting(true);
      await deleteItem(item._id);
      toast.success(
        `${item.type === "file" ? "File" : "Folder"} deleted successfully`
      );
      setShowDeleteModal(false);
      onRefresh?.();
    } catch (error) {
      console.error("Delete error:", error);
      toast.error(error.message || `Failed to delete ${item.type}`);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
  };

  const handleDownload = async (e) => {
    e.stopPropagation();
    if (isDownloading) return;

    try {
      setIsDownloading(true);
      await downloadFile(item._id);
      toast.success(`Downloading ${item.name}`);
    } catch (error) {
      console.error("Download error:", error);
      toast.error(error.message || "Failed to download file");
    } finally {
      setIsDownloading(false);
    }
  };

  console.log('testing log added in fileGridItem: ',item)

  return (
    <>
      <div
        className={`file-item-glassy ${
          item.type === "folder" ? "folder" : "file"
        }`}
        onClick={() =>
          item.type === "folder" ? onFolderClick(item._id) : onFileClick(item)
        }
        style={{
          ...styles?.fileCard,
          cursor: item.type === "folder" ? "pointer" : "default",
          background:
            item.type === "folder"
              ? "rgba(236,244,255,0.85)"
              : "rgba(255,255,255,0.92)",
          position: "relative",
          borderRadius: "12px",
          padding: "16px",
          border: "1px solid #e5e7eb",
          transition: "all 0.2s ease",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            ...styles?.fileContent,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flex: 1,
          }}
        >
          <div
            className="file-icon-glassy"
            style={{
              fontSize: item.type === "folder" ? 32 : 28,
              color: item.type === "folder" ? "#2563eb" : "#64748b",
              marginBottom: item.type === "folder" ? 8 : 6,
              filter:
                item.type === "folder"
                  ? "drop-shadow(0 2px 6px #c7d2fe)"
                  : "none",
            }}
          >
            {item.type === "folder" ? "📁" : getFileTypeIcon(item.name)}
          </div>
          <div
            className="file-name-glassy"
            style={{
              fontWeight: item.type === "folder" ? 600 : 500,
              fontSize: item.type === "folder" ? 14 : 13,
              color: item.type === "folder" ? "#1e293b" : "#334155",
              textAlign: "center",
              wordBreak: "break-all",
              lineHeight: 1.2,
              maxWidth: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              marginBottom: item.type === "file" ? 4 : 0,
            }}
          >
            {item.name || ""}
          </div>
          {item.type === "file" && (
            <div
              className="file-size-glassy"
              style={{
                fontSize: 12,
                color: "#64748b",
              }}
            >
              {formatFileSize(item?.fileMeta?.size || 0)}
            </div>
          )}
        </div>

        {item.type === "file" && (
          <div
            className="file-actions"
            style={{
              ...styles?.fileActions,
              display: "flex",
              justifyContent: "center",
              gap: "8px",
              marginTop: "8px",
            }}
          >
            <button
              style={{
                ...styles?.actionButton,
                background: "none",
                border: "none",
                padding: "6px",
                borderRadius: "6px",
                cursor: "pointer",
                color: "#64748b",
                transition: "all 0.2s ease",
              }}
              onClick={handleDownload}
              disabled={isDownloading}
              title="Download"
            >
              {isDownloading ? (
                <span style={{ fontSize: 16 }}>⏳</span>
              ) : (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
              )}
            </button>
            <button
              style={{
                ...styles?.actionButton,
                ...styles?.deleteButton,
                background: "none",
                border: "none",
                padding: "6px",
                borderRadius: "6px",
                cursor: "pointer",
                color: "#ef4444",
                transition: "all 0.2s ease",
              }}
              onClick={handleDeleteClick}
              disabled={isDeleting}
              title="Delete"
            >
              {isDeleting ? (
                <span style={{ fontSize: 16 }}>⏳</span>
              ) : (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="3 6 5 6 21 6" />
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                  <line x1="10" y1="11" x2="10" y2="17" />
                  <line x1="14" y1="11" x2="14" y2="17" />
                </svg>
              )}
            </button>
          </div>
        )}
      </div>

      <ConfirmDeleteModal
        open={showDeleteModal}
        name={item.name}
        type={item.type}
        onCancel={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
      />
    </>
  );
}

export default FileGridItem;
